import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import { PostalCodeType } from '../../../domain/model/postal-code-type.enum';

@Injectable({
    providedIn: 'root',
})
export class PostalCodeValidator {

    public static readonly GERMAN_AMOUNT_OF_CHARS = 5;
    public static readonly GERMAN_REGEX = new RegExp(`^[0-9]{${PostalCodeValidator.GERMAN_AMOUNT_OF_CHARS}}$`);

    public static readonly OTHER_AMOUNT_OF_CHARS_MIN = 3;
    public static readonly OTHER_AMOUNT_OF_CHARS_MAX = 8;
    public static readonly OTHER_REGEX = new RegExp(
        `^[a-zA-Z0-9 -]{${PostalCodeValidator.OTHER_AMOUNT_OF_CHARS_MIN},${PostalCodeValidator.OTHER_AMOUNT_OF_CHARS_MAX}}$`,
    );

    static validate(type: PostalCodeType): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            switch (type) {
                case PostalCodeType.GERMAN:
                    return this.validatePostalCodeGerman(control);
                case PostalCodeType.OTHER:
                    return this.validatePostalCodeOther(control);
                default:
                    return null;
            }
        };
    }

    private static validatePostalCodeGerman(control: AbstractControl): ValidationErrors | null {
        return this.validatePostalCode(
            control,
            PostalCodeValidator.GERMAN_AMOUNT_OF_CHARS,
            PostalCodeValidator.GERMAN_AMOUNT_OF_CHARS,
            PostalCodeValidator.GERMAN_REGEX,
        );
    }

    private static validatePostalCodeOther(control: AbstractControl): ValidationErrors | null {
        return this.validatePostalCode(
            control,
            PostalCodeValidator.OTHER_AMOUNT_OF_CHARS_MIN,
            PostalCodeValidator.OTHER_AMOUNT_OF_CHARS_MAX,
            PostalCodeValidator.OTHER_REGEX,
        );
    }

    private static validatePostalCode(control: AbstractControl, minLength: number, maxLength: number, pattern: RegExp): ValidationErrors | null {
        const minLengthValid = Validators.minLength(minLength)(control);
        if (minLengthValid !== null) {
            return minLengthValid;
        }

        const maxLengthValid = Validators.maxLength(maxLength)(control);
        if (maxLengthValid !== null) {
            return maxLengthValid;
        }

        const patternValid = Validators.pattern(pattern)(control);
        if (patternValid !== null) {
            return patternValid;
        }

        return null;
    }
}


